"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rum = exports.logger = void 0;
exports.initLogging = initLogging;
exports.updateGlobalContext = updateGlobalContext;
exports.addFeatureFlagEvaluation = addFeatureFlagEvaluation;
const browser_rum_1 = require("@datadog/browser-rum");
const browser_logs_1 = require("@datadog/browser-logs");
let defaultContext = {};
/**
 * Initializes logging with the provided configuration.
 * This should be called once at the beginning of the application.
 * @param config The configuration with which to initialize logging.
 */
function initLogging(config) {
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    const site = "datadoghq.eu";
    defaultContext = {
        git: {
            repository_url: config.repositoryUrl,
            commit: {
                sha: config.commitSha,
            },
        },
    };
    browser_rum_1.datadogRum.init({
        site,
        applicationId: config.datadogApplicationId,
        clientToken: config.datadogClientToken,
        service: config.serviceName,
        env: config.environmentName,
        version: config.version,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 10,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "mask-user-input",
        allowedTracingUrls: config.allowedUrls,
        enableExperimentalFeatures: ["feature_flags"],
    });
    browser_logs_1.datadogLogs.init({
        site,
        clientToken: config.datadogClientToken,
        service: config.serviceName,
        env: config.environmentName,
        version: config.version,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        forwardConsoleLogs: config.consoleLogs,
    });
}
/**
 * Updates the tracing and logging with information about the current user based on claims extracted from their access token.
 * @param jwtToken The JWT token to parse and update the global context with.
 */
function updateGlobalContext(jwtToken) {
    var _a, _b, _c, _d;
    var jwt = parseJwt(jwtToken);
    const context = Object.assign({ user: {
            id: jwt.extension_SimplifiUserID || "Unknown",
            name: jwt.name,
            full_name: jwt.name,
            email: jwt.emails[0] || "",
            roles: ((_a = jwt.extension_Role) === null || _a === void 0 ? void 0 : _a.split(",")) || [],
        }, simplifi: {
            user: {
                account_id: jwt.sub,
                type: jwt.extension_SimplifiUserType || "Unknown",
                id: jwt.extension_SimplifiUserID || "Unknown",
                contractor_id: jwt.extension_ContractorId,
                client_id: jwt.extension_ClientId,
                policy_schedule_ids: (_b = jwt.extension_AllowedPolicyScheduleIds) === null || _b === void 0 ? void 0 : _b.split(","),
                permissions: ((_c = jwt.extension_Permissions) === null || _c === void 0 ? void 0 : _c.split(",")) || [],
                job_types: (_d = jwt.extension_JobTypes) === null || _d === void 0 ? void 0 : _d.split(","),
            },
        } }, defaultContext);
    browser_rum_1.datadogRum.setGlobalContext(context);
    browser_logs_1.datadogLogs.setGlobalContext(context);
}
function addFeatureFlagEvaluation(key, value) {
    browser_rum_1.datadogRum.addFeatureFlagEvaluation(key, value);
}
exports.logger = browser_logs_1.datadogLogs.logger;
exports.rum = {
    /**
     * Add a custom action, stored in `@action`
     * @param name Name of the action
     * @param context Context of the action
     *
     * See [Send RUM Custom Actions](https://docs.datadoghq.com/real_user_monitoring/guide/send-rum-custom-actions) for further information.
     */
    action: browser_rum_1.datadogRum.addAction,
    /**
     * Add a custom error, stored in `@error`.
     * @param error Error. Favor sending a [Javascript Error](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error) to have a stack trace attached to the error event.
     * @param context Context of the error
     *
     * See [Send RUM Custom Actions](https://docs.datadoghq.com/real_user_monitoring/guide/send-rum-custom-actions) for further information.
     */
    error: browser_rum_1.datadogRum.addError,
};
function parseJwt(token) {
    // JWT is in the format `header.payload.signature` base64Url encoded.
    // JWT uses base64Url encoding, which is different from base64 encoding.
    // atob can also have problems with unicode characters, so this method handles that.
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""));
    return JSON.parse(jsonPayload);
}
//# sourceMappingURL=index.js.map